import { Toast } from "primereact/toast";
import { Table } from "./Table";
import { useRef } from "react";

export interface IBranchWiseIncentive {
    id?: number,
    invoice_ID?: number,
    invoiceNO?: string,
    fromDate?: Date,
    toDate?: Date,
    consultant_Name?: string,
    vendor_Company_Name?: string,
    invoiceHours?: number,
    calculatedAmount?: number,
    company_Name?: string,
    branchName?: string,
    userType?: string,
    userBranchPercentage?: number,
    userBranchAmount?: number,
}

export const BranchIncentive = () => {
    const toast = useRef<any>(null);

    return (
        <>
            <Table toast={toast} />
            <Toast ref={toast} />
        </>
    );
}